jQuery(document).ready(function ($) {

    const urlParams = new URLSearchParams(window.location.search);
    const inputParam = urlParams.get('form-input');

    if(window.location.href.indexOf("form-input") > -1) {

        let existingValues = [];

        $(".gchoice input[type=checkbox]").each(function() {
            let checkbox = ('input:checkbox[value="' + inputParam + '"]');

            let checkboxValue = $(this).val();

            existingValues.push(checkboxValue);

            if ($(checkbox)) {
                $(checkbox).parent().addClass('active');
                $(checkbox).prop('checked', true);
            }
        });

        if (existingValues.includes(inputParam) === false) {
            let checkboxElse = ('input:checkbox[value="Anders"]');
            $(checkboxElse).prop('checked', true);
            $(checkboxElse).parent().addClass('active');
        }

    }


    $('.advice-popup__close').on('click', function () {
        Cookies.set('advice_popup', 'true', {expires: 7});
        $('.advice-popup').removeClass('advice-popup--show');
        setTimeout(function () {
            $('.advice-popup').css('display', 'none');
        }, 300);
    });

    if ($(window).width() > 320) {

        if (Cookies('advice_popup') != 'true') {

            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                if (scroll >= 750) {
                    $('.advice-popup').addClass('advice-popup--show');
                } else {
                    $('.advice-popup').removeClass('advice-popup--show');
                }
            });
        }
    } else {

        if (Cookies('advice_popup') != 'true') {

            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                if (scroll >= 300) {
                    $('.advice-popup-mobile').addClass('advice-popup-mobile--show');
                } else {
                    $('.advice-popup-mobile').removeClass('advice-popup-mobile--show');
                }
            });
        }

        $('.advice-popup-mobile').on('click', function () {
            Cookies.set('advice_popup', 'true', {expires: 7});
        });
    }

});